// extracted by mini-css-extract-plugin
export var prices = "prices-module--prices--1k5mt";
export var cardContainer = "prices-module--card-container--oiPmb";
export var uiSmallText = "prices-module--ui-small-text--XFYSC";
export var compareRates = "prices-module--compare-rates--5c8kh";